import type { EventBusPayload } from "@/modules/event-bus";

import { useQueryClient } from "@tanstack/react-query";
import { useTranslation } from "react-i18next";

import { isNotificationBroadcastInterventionAssignPayload } from "@/entities/notification-broadcast";
import { useInvalidateNotificationsDatabase } from "@/entities/notifications-database";
import { useGetSettingsNotifications } from "@/entities/settings";
import { useAppNotification } from "@/modules/app-notification";

import { notifyInterventionAssign } from "./intervention-action-assign.helper";

export const useInterventionActionAssign = () => {
  const { t } = useTranslation();
  const { notify } = useAppNotification();
  const queryClient = useQueryClient();
  const { invalidateNotifications } = useInvalidateNotificationsDatabase();
  const { isBroadcastNotificationEnabled } = useGetSettingsNotifications();

  const runAction = (payload: EventBusPayload) => {
    if (!isNotificationBroadcastInterventionAssignPayload(payload)) return;
    if (isBroadcastNotificationEnabled("intervention-assign")) {
      const title = t("notification:interventionAssign.description", {
        userName: payload.user.name,
        interventionName: payload.interventions[0]?.name ?? "",
        count: payload.interventions.length,
      });
      notifyInterventionAssign({ title, notify, payload });
    }
    queryClient.invalidateQueries({ queryKey: ["interventions"] });
    queryClient.invalidateQueries({ queryKey: ["organizations", "list"] }); // context dropdown
    invalidateNotifications("*");
  };

  return { runAction };
};
